import { UntypedFormBuilder, Validators } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { Constants } from "src/app/shared/model/Constants";


export interface ProofDocument {
    id: number;
    typeId: number;
    kindId: number;
    conformityId: number;
    requiredFrom: number;
    claimIdentifier: string;
    createdBy?: string ;
    timestamp?: string ;
    description : string;
    linkedClaimDocumentCount?: boolean;
}

export class ProofDocumentFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, proofDocument: ProofDocument) {
  
      return fb.group(
        {
            id: [proofDocument.id],
            typeId: [proofDocument.typeId,[Validators.required, Validators.min(1)]],
            kindId: [proofDocument.kindId,[Validators.required, Validators.min(1)]],
            conformityId: [proofDocument.conformityId,[Validators.required, Validators.min(1)]],
            claimIdentifier: [proofDocument.claimIdentifier],
            requiredFrom:  [proofDocument.requiredFrom,[Validators.required, Validators.min(1)]],
            description: [proofDocument.description],
        }       
      );
    }

    static  initProofDocument():ProofDocument {
  
      return {
          id:0,
        claimIdentifier:  Constants.EmptyGuid,
        typeId: 0,
        kindId:  Constants.ProofDocumentKindIdMandatory,
        conformityId:  Constants.ProofDocumentConformityIdNotDelivered,
        requiredFrom:  Constants.ProofDocumentRequiredFromClient,
        description: ''
      };
    }
  }